'use strict';

import { EwSiteApp } from '../../app/ewsiteapp';
import { Fancybox } from "@fancyapps/ui";

EwSiteApp.controller('ElectricityConnCalcHome', ['$scope', '$timeout', '$http', 'ajaxSearch', function ($scope, $timeout, $http, ajaxSearch) {
	$scope.changeState = function (field_id, state) {
		if (typeof ($scope.requiredFields['field_' + field_id]) !== 'undefined') {
			$scope.requiredFields['field_' + field_id].valid = state;
		}
	};

	$scope.addRequired = function (field_id) {
		if (typeof ($scope.requiredFields['field_' + field_id]) === 'undefined') {
			$scope.requiredFields['field_' + field_id] = {
				id: field_id,
				valid: false
			};
		}
		if (arguments[1] && typeof (arguments[1]) !== 'undefined') {
			$scope.requiredFields['field_' + field_id].parent_field_id = arguments[1];
		}
	};
	$scope.ikainiuGrupes = [
		{ min: 0, max: 100, kw_kaina: 160.30, text: "I grupė (atstumas iki 100 m)" },
		{ min: 100, max: 400, kw_kaina: 318.33, text: "II grupė (atstumas 100 m - 400 m)" },
		{ min: 400, max: 1000, kw_kaina: 750.53, text: "III grupė (atstumas nuo 400 m - 1000 m)" },
		{ min: 1000, max: Infinity, kw_kaina: null, text: "Jei atstumas nuo 1000 m kaina pagal faktines išlaidas" }
	];

	$scope.faktinesIslaidosModal = false;

	$scope.showModalFaktines = function () {
		$scope.faktinesIslaidosModal = !$scope.faktinesIslaidosModal;
		angular.element(document.querySelector('body')).toggleClass('calc-overflow-hidden');
	};

	// Function to add breadcrumb
	$scope.addBreadcrumb = function (title, link = 'javascript:void(0)') {
		$scope.breadcrumbs.push({ title, link });
	};

	// Function to remove last breadcrumb
	$scope.removeLastBreadcrumb = function () {
		if ($scope.breadcrumbs.length > 1) {
			$scope.breadcrumbs.pop();
		}
	};

	$scope.breadcrumbs = [];
	$scope.manualSelection = false;
	$scope.sum = '';
	$scope.sum_pvm = '';
	$scope.paslauga = true;
	$scope.galiosDidinimas = false;
	$scope.galiosmazinimas = false;
	$scope.duomenuInformacija = false;
	$scope.objectSearched = false;
	$scope.objektoTipas = false;
	$scope.objektoInformacija = false;
	$scope.elektrosIrenginioGalia = null;
	$scope.irenginioGalia = false;
	$scope.esamaGalia = false;
	$scope.esamaGaliaValue = null;
	$scope.irenginioEsamaGaliaValue = null;
	$scope.ikrovimoStotele = false;
	$scope.ikrovimoStoteleReikalinga = undefined;
	$scope.galiosPoreikis = false;
	$scope.galiosPoreikiaiValue = '';
	$scope.customSelected = false;
	$scope.customGaliosPoreikisValue = null;
	$scope.vietosNustatymas = false;
	$scope.vietosNustatymasInput = '';
	$scope.apskaiciuotaSuma = false;

	$scope.butasSelected = false;
	$scope.namasSelected = false;
	$scope.statiniaiSelected = false;
	$scope.objDataUrl = lcc_params.obj_data_url;
	$scope.object_nr = '';
	$scope.object_address = '';
	$scope.max_vartota = null;
	$scope.obj_galia = null;
	$scope.galios_isnaudojimas = null;
	$scope.error_message = '';
	$scope.requiredFields = [];
	$scope.bad_address_length = 5;
	$scope.addresses_1 = [];
	$scope.findUrl = lcc_params.findUrl;
	$scope.fieldId = 0;
	$scope.show_bad_searches = false;
	$scope.noAddressFound = false;
	$scope.duomenysIvesiuPats = false;
	$scope.value_text = {};
	$scope.embedTid;

	$scope.searchObject = function () {
		$scope.checking_object = true;
		$scope.error_message = '';
		if ($scope.objDataUrl !== '' && $scope.object_nr !== '' && $scope.object_address !== '') {
			$http({
				method: 'POST',
				url: $scope.objDataUrl,
				data: {
					obj_nr: $scope.object_nr,
					address: $scope.object_address
				},
				xsrfCookieName: secure_xsrf_name,
				xsrfHeaderName: 'X-' + secure_xsrf_name
			}).then(function (response) {
				if (response.data.success) {
					$scope.objectSearched = true;
					$scope.obj_galia = response.data.data.obj_galia;
					$scope.esamaGaliaValue = parseFloat($scope.obj_galia) || 0;
					$scope.max_vartota = response.data.data.max_vartota;
					$scope.galios_isnaudojimas = response.data.data.galios_isnaudojimas;
				} else {
					$scope.error_message = response.data.message;
					$scope.objectSearched = false;
					$scope.obj_galia = null;
					$scope.max_vartota = null;
					$scope.galios_isnaudojimas = null;
				}
			}, function (response) {
				console.log(['Error', response]);
			}).then(function () {
				$scope.checking_object = false;
			});
		}
	};

	$scope.defaultUrlParams = function () {
		return {
			paslauga: '',
			tipas: '',
			galia: '',
			ikrovimostotele: '',
			duomenys: '',
			esamagalia: '',
			irenginiogalia: '',
			atstumas: '',
			objektas: '',
		};
	};

	//Back to start
	$scope.reset = function () {
		$scope.breadcrumbs = [];
		$scope.duomenisIvesiuPats = false;
		$scope.manualSelection = false;
		$scope.sum = '';
		$scope.sum_pvm = '';
		$scope.paslauga = true;
		$scope.galiosDidinimas = false;
		$scope.galiosmazinimas = false;
		$scope.duomenuInformacija = false;
		$scope.objectSearched = false;
		$scope.objektoTipas = false;
		$scope.objektoInformacija = false;
		$scope.object_nr = '';
		$scope.object_address = '';
		$scope.max_vartota = null;
		$scope.obj_galia = null;
		$scope.galios_isnaudojimas = null;
		$scope.irenginioGalia = false;
		$scope.elektrosIrenginioGalia = null;
		$scope.esamaGalia = false;
		$scope.esamaGaliaValue = null;
		$scope.irenginioEsamaGaliaValue = null;
		$scope.ikrovimoStotele = false;
		$scope.ikrovimoStoteleReikalinga = undefined;
		$scope.galiosPoreikis = false;
		$scope.galiosPoreikiaiValue = '';
		$scope.customSelected = false;
		$scope.customGaliosPoreikisValue = null;
		$scope.vietosNustatymas = false;
		$scope.vietosNustatymasInput = '';
		$scope.apskaiciuotaSuma = false;

		$scope.butasSelected = false;
		$scope.namasSelected = false;
		$scope.statiniaiSelected = false;
		$scope.show_bad_searches = false;
		$scope.noAddressFound = false;
		$scope.duomenysIvesiuPats = false;
		$scope.clearAddressSugggests();

		$scope.urlParams = $scope.defaultUrlParams();

		if ($scope.inputForm) {
			// Reset the form state
			$scope.inputForm.$setPristine();
			$scope.inputForm.$setUntouched();
			$scope.inputForm.$setValidity();
			$scope.error_message = '';

			angular.forEach(angular.element('input'), function (inputElement) {
				inputElement = angular.element(inputElement);
				inputElement.removeClass('ng-valid ng-invalid ng-dirty ng-touched ng-untouched ng-pristine ng-pending');
			});
		}

		$timeout(function () {
			$scope.inputForm.$setPristine();
			$scope.inputForm.$setUntouched();
		}, 0);

		// Force digest to clear cache
		$scope.$applyAsync();
	};

	// Handle back from galiosPoreikis
	$scope.handleBackClick = function () {
		if ($scope.esamaGaliaValue && !$scope.objectSearched) {
			$scope.esamaGalia = true;
			$scope.galiosPoreikis = false;
		} else if ($scope.namasSelected && ($scope.ikrovimoStoteleReikalinga || !$scope.ikrovimoStoteleReikalinga)) {
			$scope.ikrovimoStotele = true;
			$scope.galiosPoreikis = false;
		} else if ($scope.objectSearched) {
			$scope.irenginioGalia = true;
			$scope.galiosPoreikis = false;
		} else {
			$scope.objektoTipas = true;
			$scope.galiosPoreikis = false;
		}
		$scope.changeUrlParamsWhenNavigatingBack();
	};

	$scope.changeUrlParamsWhenNavigatingBack = function (remove_arg) {
		/*if($scope.urlParams.galia!==""){
			$scope.urlParams.galia = "";
		}
		else if($scope.urlParams.tipas!=="" && !$scope.ikrovimoStotele){
			$scope.urlParams.tipas = "";
		}
		else if($scope.urlParams.ikrovimostotele!=="" && $scope.namasSelected && ($scope.ikrovimoStoteleReikalinga || !$scope.ikrovimoStoteleReikalinga)){
			$scope.urlParams.ikrovimostotele = "";
		}
		else if($scope.urlParams.duomenys && !$scope.esamaGalia){
			$scope.urlParams.duomenys = "";
		}
		else if($scope.urlParams.esamagalia!==""){
			$scope.urlParams.esamagalia = "";
		}
		else if($scope.urlParams.atstumas!=="" && $scope.vietosNustatymas){
			$scope.urlParams.atstumas = "";
			$scope.vietosNustatymasInput = "";
			$scope.atstumasValue = "";
		}*/

		switch (remove_arg) {
			case 'tipas':
				if ($scope.ikrovimoStotele && $scope.namasSelected && $scope.urlParams.ikrovimostotele !== "") {
					$scope.urlParams.ikrovimostotele = "";
				}
				else if ($scope.esamaGalia && !$scope.galiosPoreikis) {
					console.log('111');
					$scope.urlParams.esamagalia = "";
				}
				else {
					$scope.urlParams.tipas = "";
					if ($scope.urlParams.irenginiogalia !== "") {
						$scope.urlParams.irenginiogalia = "";
					}
				}
				break;
			case 'duomenys':
				$scope.urlParams.duomenys = "";
				break;
			case 'galia':
				$scope.urlParams.galia = "";
				break;
			case 'atstumas':
				$scope.urlParams.atstumas = "";
				$scope.vietosNustatymasInput = "";
				$scope.atstumasValue = "";
				break;
			case 'objektas':
				$scope.urlParams.objektas = "";
				$scope.urlParams.adresas = "";
				if ($scope.urlParams.esamagalia !== "") {
					$scope.urlParams.esamagalia = "";
				}
				break;
			default:

		}
		setQueryData();
	};

	$scope.resetEsamaGaliaValue = function () {
		$scope.esamaGaliaValue = '';
	};

	//Pasirinkti paslauga
	$scope.paslaugos = [
		{
			icon: 'namas_su_kistuku_ir_zaibu',
			title: 'namams',
			paslauga: 'naujasivedimas',
			onClick: function () {
				$scope.paslauga = false;
				$scope.objektoTipas = true;
				$scope.embedTid = 6;
				$scope.addBreadcrumb('Pageidaujama paslauga: Naujas įvedimas');
				$scope.setUrlArgPaslauga('naujasivedimas');
			}
		},
		{
			icon: 'skaitliukas_su_zaibu',
			title: 'galios_didinimas',
			paslauga: 'galiosdidinimas',
			onClick: function () {
				$scope.paslauga = false;
				//					$scope.esamaGalia = true;
				$scope.duomenuInformacija = true;
				$scope.galiosDidinimas = true;
				$scope.embedTid = 7;
				$scope.addBreadcrumb('Pageidaujama paslauga: Galios didinimas');
				$scope.setUrlArgPaslauga('galiosdidinimas');
				console.log($scope.paslauga);
			}
		},
		{
			icon: 'skaitliukas_su_zaibu',
			title: 'galios_mazinimas',
			paslauga: 'galiosmazinimas',
			onClick: function () {
				$scope.paslauga = false;
				//					$scope.esamaGalia = true;
				$scope.objektoInformacija = true;
				$scope.galiosmazinimas = true;
				$scope.embedTid = 8;
				$scope.addBreadcrumb('Pageidaujama paslauga: Galios mažinimas');
				$scope.setUrlArgPaslauga('galiosmazinimas');
			}
		}
	];
	//Pasirinkti paslauga
	$scope.duomenys = [
		{
			icon: 'zmogus',
			title: 'duomenis_suvesiu_pats',
			duomenys: 'suvesiupats',
			onClick: function () {
				$scope.duomenuInformacija = false;
				$scope.esamaGalia = true;
				$scope.addBreadcrumb('Duomenys: Duomenis suvesiu pats');
				$scope.object_nr = null;
				$scope.object_address = null;
				$scope.max_vartota = null;
				$scope.obj_galia = null;
				$scope.galios_isnaudojimas = null;
				$scope.inputForm?.$setPristine();
				$scope.inputForm?.$setUntouched();
				$scope.inputForm?.$setValidity();
				$scope.setUrlArgDuomenys('suvesiupats');
			}
		},
		{
			icon: 'skaitliukas_su_zaibu',
			title: 'naudoti_mano_skaitliuko_duomenis',
			duomenys: 'skaitiklio',
			disabled: false,
			onClick: function () {
				$scope.duomenuInformacija = false;
				$scope.objektoInformacija = true;
				$scope.addBreadcrumb('Duomenys: Naudoti mano skaitiklio duomenis');
				$scope.setUrlArgDuomenys('skaitiklio');
			}
		}
	];

	//Pasirinkti objekto tipa
	$scope.objektoTipai = [
		{
			icon: 'daugiabutis',
			title: 'butas',
			onClick: function () {
				$scope.objektoTipas = false;
				$scope.galiosPoreikis = true;
				$scope.butasSelected = true;
				$scope.statiniaiSelected = false;
				$scope.namasSelected = false;
				$scope.addBreadcrumb('Objekto tipas: Butas');
				$scope.setUrlArgTipas('butas');
			}
		},
		{
			icon: 'mazas_namelis',
			title: 'namas',
			onClick: function () {
				$scope.objektoTipas = false;
				$scope.ikrovimoStotele = true;
				$scope.namasSelected = true;
				$scope.butasSelected = false;
				$scope.statiniaiSelected = false;
				$scope.addBreadcrumb('Objekto tipas: Namas');
				$scope.setUrlArgTipas('namas');
			}
		},
		{
			icon: 'garazas',
			title: 'statiniai',
			onClick: function () {
				$scope.objektoTipas = false;
				$scope.galiosPoreikis = true;
				$scope.statiniaiSelected = true;
				$scope.namasSelected = false;
				$scope.butasSelected = false;
				$scope.addBreadcrumb('Objekto tipas: Statiniai');
				$scope.setUrlArgTipas('statiniai');
			}
		},
		{
			icon: 'priekaba',
			title: 'kilnojami_statiniai',
			onClick: function () {
				$scope.showModalFaktines();
				$scope.setUrlArgTipas('kilnojamistatiniai');
			}
		}
	];

	//Pasirinkti galios poreiki
	$scope.galiosPoreikiai = [
		{ label: '3 kW', value: 3 },
		{ label: '4 kW', value: 4 },
		{ label: '5 kW', value: 5 },
		{ label: '7 kW', value: 7 },
		{ label: '9 kW', value: 9 },
		{ label: '11 kW', value: 11 },
		{ label: '14 kW', value: 14 },
		{ label: '18 kW', value: 18 },
		{ label: '22 kW', value: 22 },
		{ label: '28 kW', value: 28 },
		{ label: '35 kW', value: 35 },
		{ label: '45 kW', value: 45 },
		{ label: '>=60 kW', value: null, key: 'custom' }
	];
	$scope.customGaliosPoreikisValue = null;

	$scope.isDisabled = function (galia) {
		if (galia.value === null) {
			return false;
		}
		if ($scope.objectSearched) {
			return galia.value <= $scope.calculatedValue;
		} else {
			return galia.value <= $scope.esamaGaliaValue;
		}
	};

	$scope.check = function (galia) {
		$scope.manualSelection = true;
		$scope.galiosPoreikiaiValue = galia.value; // Update selected value
		// Reset customGaliosPoreikisValue if galia.value is not null
		if (galia.key === 'custom') {
			$scope.customSelected = true;
		} else {
			$scope.customSelected = false;
		}
		if (galia.value !== null) {
			$scope.customGaliosPoreikisValue = null; // Reset the custom value
		}
		//			$scope.setUrlArgGalia();
	};


	$scope.$watchGroup(['objektoInformacija', 'esamaGalia', 'irenginioEsamaGaliaValue', 'esamaGaliaValue', 'statiniaiSelected', 'butasSelected', 'namasSelected', 'ikrovimoStoteleReikalinga'], function (newValues) {
		const [objektoInformacija, esamaGalia, irenginioEsamaGaliaValue, esamaGaliaValue, statiniaiSelected, butasSelected, namasSelected, ikrovimoStoteleReikalinga] = newValues;
		if ($scope.objectSearched) {
			if (!ikrovimoStoteleReikalinga) {
				$scope.calculatedValue = Math.round((parseFloat($scope.max_vartota) || 0) + (parseFloat($scope.irenginioEsamaGaliaValue) || 0));
				$scope.galiosPoreikiaiValue = $scope.calculatedValue;
			} else if (ikrovimoStoteleReikalinga && irenginioEsamaGaliaValue < 11) {
				$scope.calculatedValue = Math.round((parseFloat($scope.max_vartota) || 0) + (parseFloat($scope.irenginioEsamaGaliaValue) || 0));
				$scope.galiosPoreikiaiValue = $scope.calculatedValue;
			} else if (ikrovimoStoteleReikalinga && $scope.irenginioEsamaGaliaValue >= 11) {
				$scope.calculatedValue = Math.round((parseFloat($scope.max_vartota) || 0) + 11);
				$scope.galiosPoreikiaiValue = $scope.calculatedValue;
			} else {

			}

			// Automatically select the closest higher value from galiosPoreikiai
			const availableValues = $scope.galiosPoreikiai.map(item => item.value).filter(value => value !== null);
			const closestValue = availableValues.filter(value => value >= $scope.galiosPoreikiaiValue);
			if (closestValue.length > 0) {
				$scope.galiosPoreikiaiValue = closestValue[0]; // Select the closest higher value
			}

			// Show customGaliosPoreikisValue if galiosPoreikiaiValue > 59
			if ($scope.galiosPoreikiaiValue > 59) {
				$scope.customGaliosPoreikisValue = $scope.galiosPoreikiaiValue; // Assign the calculated value
			} else {
				$scope.customGaliosPoreikisValue = null; // Reset if not applicable
			}
		}

		if (!$scope.manualSelection) {
			if (statiniaiSelected && $scope.galiosPoreikiaiValue !== 11) {
				$scope.galiosPoreikiaiValue = 11; // Automatically select 11
			}
			if (butasSelected && $scope.galiosPoreikiaiValue !== 7) {
				$scope.galiosPoreikiaiValue = 7; // Automatically select 7
			}
			if (namasSelected) {
				if (ikrovimoStoteleReikalinga && $scope.galiosPoreikiaiValue !== 18) {
					$scope.galiosPoreikiaiValue = 18; // Automatically select 18
				} else if (!ikrovimoStoteleReikalinga && $scope.galiosPoreikiaiValue !== 14) {
					$scope.galiosPoreikiaiValue = 14; // Automatically select 14
				}
			}

			if (esamaGalia && esamaGaliaValue === null) {
				$scope.galiosPoreikiaiValue = '';
			}

			if ($scope.customSelected) {
				$scope.galiosPoreikiaiValue = null;
			}
		}
	});


	$scope.handleGaliosPoreikisChange = function (galia) {
		manualSelection = true;
		if ($scope.galiosPoreikiaiValue !== galia.value) {
			$scope.galiosPoreikiaiValue = galia.value;
		}
	};

	$scope.checkMaxLength = function (event) {
		// Prevent typing more than 3 characters
		if ($scope.customGaliosPoreikisValue && $scope.customGaliosPoreikisValue.toString().length >= 3 && event.key !== 'Backspace') {
			event.preventDefault();
		}
	};

	//Atstumas
	$scope.patvirtintiAtstuma = function () {
		//			$scope.galiosPoreikisValue = parseFloat($scope.galiosPoreikisValue);
		$scope.atstumasValue = $scope.vietosNustatymasInput;

		if ($scope.atstumasValue !== '') {
			$scope.vietosNustatymas = false;
			$scope.apskaiciuotaSuma = true;
			if ($scope.atstumasValue > 1000) {
				$scope.atstumasVirs1000 = true;
			} else {
				$scope.atstumasVirs1000 = false;
			}
			$scope.apskaiciuotiSuma();
			$scope.setUrlArgAtstumas();
		}
	};

	$scope.calculateSumWithPVM = function (kw_kaina, galiosPoreikiaiValue) {
		const sum = kw_kaina * galiosPoreikiaiValue;
		const sum_pvm = (sum * 1.21).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, '');
		return { sum, sum_pvm };
	};

	// Function to calculate the total sum and group based on distance
	$scope.apskaiciuotiSuma = function () {
		// Find the appropriate rate group based on the distance
		const selectedGrupe = $scope.ikainiuGrupes.find(grupe => $scope.atstumasValue >= grupe.min && $scope.atstumasValue < grupe.max);

		// Set the group text
		$scope.grupe = selectedGrupe.text;
		$scope.addBreadcrumb('Prijungimo įkainių grupės: ' + $scope.grupe);
		// Check if esamaGaliaValue exists
		let galiosPoreikiaiAdjusted = $scope.galiosPoreikiaiValue;
		if ($scope.esamaGaliaValue || ($scope.objectSearched && $scope.irenginioEsamaGaliaValue)) {
			// Subtract esamaGaliaValue from galiosPoreikiaiValue
			galiosPoreikiaiAdjusted = $scope.galiosPoreikiaiValue - $scope.esamaGaliaValue;

			// Ensure that the adjusted value doesn't go below 0
			galiosPoreikiaiAdjusted = Math.max(galiosPoreikiaiAdjusted, 0);
		}

		// If there is a valid kw_kaina, calculate the sum and sum_pvm
		if (selectedGrupe.kw_kaina) {
			const sum = (selectedGrupe.kw_kaina * galiosPoreikiaiAdjusted).toFixed(2); // Ensure 2 decimal places
			const sum_pvm = (sum * 1.21).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, '');

			$scope.sum = sum;
			$scope.sum_pvm = sum_pvm;
		} else {
			// If kw_kaina is null (for distance > 1000m), no sum is calculated
			$scope.sum = null;
			$scope.sum_pvm = null;
		}
	};


	// REGIA CALC GPS
	// REGIA CALC GPS
	// REGIA CALC GPS
	var regia_params = lcc_params.regia;
	var regia_domain = lcc_params.regia.domain;
	var distance_url = lcc_params.distance_url;
	var eims_distance_url = lcc_params.eims_distance_url;
	var translations = lcc_params.translations;
	//var self = $(this);
	this.cache = {};

	var self = this;

	this.getT = function (msg) {
		if (typeof (translations[msg]) === 'undefined') {
			return '*' + msg + '*';
		}
		return translations[msg];
	};

	//		$('body').on('click', '.municipality', function () {
	//			openRegiaByMunicipality($(this).data('key'));
	//		});

	$("#openregiamap").click(function (e) {
		e.preventDefault();
		openRegiaIframe();
	});
	$("#distance_by_gps a").click(function (e) {
		e.preventDefault();
		openRegiaByGps();
	});

	//		function openRegiaByMunicipality(key) {
	//			var municipality = key;
	//			if (!municipality) {
	//				return false;
	//			}
	//
	//			var url = regia_domain + (regia_params.municipality_path.replace('%MUNI%', municipality));
	//			const instance = Fancybox.getInstance();
	//			if (instance) {
	//				instance.close();
	//			}
	//			openRegiaIframe(url);
	//		}

	//		$scope.openRegiaIframe = function(){
	//			openRegiaIframe();
	//		}

	function isIOS() {
		return (/iPad|iPhone|iPod|Mac OS/.test(navigator.userAgent) || (navigator.userAgent.includes('Mac') && 'ontouchend' in document));
	}

	function openRegiaIframe() {
		var url = regia_domain + (regia_params.path);
		showLoading('loading_regia_map');
		Fancybox.show([{
			type: 'iframe',
			src: url,
			width: '100%',
			autoSize: false,
			autoHeight: true,
			autoWidth: false,
			fitToView: true,
			closeButton: false,
			on: {
				init: (fancybox) => {
					hideLoading('loading_regia_map');
					document.body.style.overflowY = "hidden";
					document.body.style.position = "fixed";
				},
				destroy: (fancybox) => {
					hideLoading('loading_regia_map');
					document.body.style.overflowY = "";
					document.body.style.position = "";
				}
			}
		}]);
		$timeout(() => {
			hideLoading('loading_regia_map');
		}, 2500);
		if (isIOS()) {
			$timeout(() => {
				$('.fancybox__container .is-loading').removeClass('is-loading');
				$('.fancybox__container .fancybox-spinner').remove();
			}, 3000);
		}
	}
	;

	function receiveRegiaData(event) {
		// Close the current Fancybox if one is open
		const instance = Fancybox.getInstance();
		if (instance) {
			instance.close();
		}
		if (event.origin !== regia_domain) {
			return;
		}
		if (event.data) {
			var result = event.data.data;
			showDistance(result.x, result.y);
		}
	}

	window.addEventListener('message', receiveRegiaData, false);
	function showDistance(x, y, type) {
		if (typeof distance_url !== 'string') {
			return false;
		}
		type = typeof type == 'undefined' ? '' : type;
		showLoading('loading_text');
		$.ajax({
			type: 'GET',
			url: distance_url,
			data: { x: x, y: y, type: type },
			success: function (resp) {
				//				console.log('success');
				if (resp.success) {
					$scope.vietosNustatymasInput = resp.distance;
					$scope.patvirtintiAtstuma();
					$timeout(function () {
						$scope.$apply();
					});
					//					$('#lcc_ga_val').val(resp.distance).trigger("keyup");
					//					const gisValue = $('#lcc_ga_val').val();
					//					appendDistanceGroup(gisValue);
				} else {
					alert(resp.message);
				}
			},
			error: function (xhr, ajaxOptions, thrownError) {
				//				console.log('error');
				alert('Distance request error: ' + xhr.status + ' ' + thrownError);
			},
			complete: function () {
				hideLoading('loading_text');
				hideLoading('loading_regia_map');
				//				console.log('complete');
			}
		});
	}

	$scope.distanceByObjektoNr = function () {
		showDistanceEims({ objekto_nr: $scope.object_nr });
	};

	$scope.distanceByAddress = function () {
		showDistanceEims({ address: $scope.value_text[1] });
	};

	function showDistanceEims(postdata) {
		if (typeof eims_distance_url !== 'string') {
			return false;
		}
		showLoading('loading_text');
		$.ajax({
			type: 'GET',
			url: eims_distance_url,
			data: postdata,
			success: function (resp) {
				//				console.log('success');
				if (resp.success) {
					$scope.vietosNustatymasInput = resp.distance;
					$scope.patvirtintiAtstuma();
					$timeout(function () {
						$scope.$apply();
					});
					//					$('#lcc_ga_val').val(resp.distance).trigger("keyup");
					//					const gisValue = $('#lcc_ga_val').val();
					//					appendDistanceGroup(gisValue);
				} else {
					alert(resp.message);
				}
			},
			error: function (xhr, ajaxOptions, thrownError) {
				//				console.log('error');
				alert('Distance request error: ' + xhr.status + ' ' + thrownError);
			},
			complete: function () {
				hideLoading('loading_text');
				hideLoading('loading_regia_map');
				//				console.log('complete');
			}
		});
	}

	function openRegiaByGps() {
		if (!('geolocation' in navigator)) {
			alert('Geolocation is not supported by this browser');
			return false;
		}

		navigator.geolocation.getCurrentPosition(
			function (pos) {
				self.cache.latitude = pos.coords.latitude;
				self.cache.longitude = pos.coords.longitude;
				showDistance(self.cache.latitude, self.cache.longitude, 'latlng');
			},
			function (error) {
				if (typeof (self.cache.latitude) !== 'undefined' && typeof (self.cache.longitude) !== 'undefined') {
					showDistance(self.cache.latitude, self.cache.longitude, 'latlng');
				} else {
					alert('Neperduotos koordinatės skaičiuoklei, peržiūrėkite įrenginio nustatymus');
				}

			}
		);
	}

	function showLoading(text_id) {
		var id = 'calc-loading';
		if ($('#' + id).length) {
			return;
		}
		$('body').append('<div id="' + id + '" class="' + text_id + '"><div>' + self.getT(text_id) + '</div></div>');
	}

	function hideLoading(text_id) {
		text_id = (typeof text_id === 'string') ? '.' + text_id : '';
		$('#calc-loading' + text_id).remove();
	}
	// END REGIA CALC GPS
	// END REGIA CALC GPS
	// END REGIA CALC GPS

	$scope.initController = function (fieldId, required) {
		$scope.fieldId = fieldId;
		if (required) {
			$scope.addRequired($scope.fieldId);
			$timeout(function () {
				$scope.addressChanged();
			}, 50);
		}
	};

	$scope.getFieldModel = function () {
		return $scope.obj_address[$scope.fieldId];
	};
	$scope.findAddress = function () {
		$scope.uvis_address_id = null;
		$scope.addressChanged();
		if ($scope.findUrl !== '' && $scope.value_text[$scope.fieldId] != '') {
			$scope.loading = true;
			$scope.show_bad_searches = false;
			$scope.clearAddressSugggests();
			ajaxSearch.search($scope.findUrl, { address: $scope.value_text[$scope.fieldId] }).then(function (response) {
				if (response.success) {
					$scope.addresses = response.items;
					if ($scope.addresses.length > 0) {
						$scope.showSuggest = true;
						$scope.noAddressFound = false;
						$scope.show_bad_searches = false;
					} else {
						$scope.addresses = [];
						$scope.messages = response.messages;
						$scope.noAddressFound = true;
						$scope.showSuggest = false;

						/*$scope.number_bad_searches += 1;
						 if ($scope.number_bad_searches >= $scope.limit_bad_searches) {
						 $scope.show_bad_searches = true;
						 }*/
						if ($scope.value_text[$scope.fieldId] !== '' && $scope.value_text[$scope.fieldId].length >= $scope.$parent.bad_address_length) {
							//							console.log($scope.value_text[$scope.fieldId].length, $scope.$parent.bad_address_length)
							$scope.show_bad_searches = true;
						}
					}
					$scope.loading = false;
				}
			}, function (response) {
				$log.error(response);
			});
		} else {
			$scope.clearAddressSugggests();
			$scope.object_address = '';
			$scope.obj_galia = '';
			$scope.max_vartota = '';
			$scope.galios_isnaudojimas = '';
		}
	};

	$scope.setAddress = function (address) {
		$scope.checking_object = false;
		$scope.object_address = address._source.adr_id;
		$scope.value_text[$scope.fieldId] = address._source.adr_sudetinis_adresas;
		$scope.addressChanged();
		$scope.clearAddressSugggests();
	};

	$scope.clearAddressSugggests = function () {
		$scope.showSuggest = false;
		$scope.addresses = [];
		$scope.messages = [];
	};

	$scope.addressChanged = function () {
		if (($scope.value_text[$scope.fieldId] === 'undefined' || $scope.value_text[$scope.fieldId] === '')) {
			$scope.changeState($scope.fieldId, false);
			return;
		}

		if ($scope.value_text[$scope.fieldId] && $scope.value_text[$scope.fieldId] !== '') {
			$scope.changeState($scope.fieldId, true);
		}

	};

	$scope.urlParams = $scope.defaultUrlParams();
	var searchObj = {};
	var queryString = '';

	function parseSearch() {
		queryString = window.location.search;
		let pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('_');
		for (var i = 0; i < pairs.length; i++) {
			let pair = pairs[i].split('-');
			let name = decodeURIComponent(pair[0]);
			searchObj[name] = decodeURIComponent(pair[1] || '');
			//				if(name === 'tipas'){
			//					searchObj[name] = searchObj[name].split(',');
			//				}
		}

	}
	parseSearch();

	function setQueryData() {
		queryString = '?' + formatHistoryQuery();
		history.pushState("", document.title, window.location.pathname + queryString);
	}

	function formatHistoryQuery() {
		let el = [];

		for (var i in $scope.urlParams) {
				/*if(i==='tipas'){
					if($scope.urlParams['tipas'].length>0){
						el.push(i+'-'+$scope.urlParams['tipas'].join(','));
					}
				}
				else */if (typeof ($scope.urlParams[i]) !== 'undefined' && $scope.urlParams[i] !== '') {
				el.push(i + '-' + $scope.urlParams[i]);
			}
		}

		return el.join('_');
	}

	$scope.setUrlArgPaslauga = function (paslauga) {
		$scope.urlParams.paslauga = paslauga;
	};

	$scope.setUrlArgTipas = function (tipas) {
		//			let indx = $scope.urlParams.tipas.indexOf(tipas);
		//			if(indx===-1){
		//				$scope.urlParams.tipas.push(tipas);
		//				setQueryData();
		//			}
		$scope.urlParams.tipas = tipas;
		setQueryData();
	};

	$scope.setUrlArgGalia = function () {

		//			$scope.addBreadcrumb('Galios poreikis: ' + ($scope.galiosPoreikiaiValue !== null ? $scope.galiosPoreikiaiValue : $scope.customGaliosPoreikisValue) + ' kW');

		if ($scope.customSelected) {
			$scope.urlParams.galia = $scope.customGaliosPoreikisValue;
			//				$scope.urlParams.galia = 60;
		}
		else {
			$scope.urlParams.galia = $scope.galiosPoreikiaiValue;
		}
		setQueryData();
	};

	$scope.setUrlArgIkrovimoStotele = function () {
		$scope.addBreadcrumb('Įkrovimo stotelė: ' + ($scope.ikrovimoStoteleReikalinga ? 'Taip' : 'Ne'));
		if ($scope.ikrovimoStoteleReikalinga) {
			$scope.urlParams.ikrovimostotele = 1;
		}
		else {
			$scope.urlParams.ikrovimostotele = 0;
		}
		setQueryData();
	};

	$scope.setUrlArgDuomenys = function (duomenys) {
		$scope.urlParams.duomenys = duomenys;
		setQueryData();
	};

	$scope.setUrlArgEsamaGalia = function (esamagalia) {
		$scope.esamaGaliaValue = parseInt(esamagalia);
		$scope.urlParams.esamagalia = parseInt(esamagalia);
		setQueryData();
	};

	$scope.setUrlArgAtstumas = function () {
		$scope.urlParams.atstumas = $scope.atstumasValue;
		setQueryData();
	};

	$scope.setUrlArgObjektas = function () {
		$scope.urlParams.objektas = $scope.object_nr;
		$scope.urlParams.adresas = $scope.object_address;
		//			$scope.urlParams.adresas = $scope.value_text[1];
		setQueryData();
	};

	$scope.setUrlArgObjEsamaGalia = function () {
		if (!$scope.irenginioGalia && typeof (searchObj.objektas) !== 'undefined') {
			$scope.addBreadcrumb('Esama galia: ' + $scope.esamaGaliaValue + 'kW');
		}
		$scope.urlParams.esamagalia = $scope.esamaGaliaValue;

		if ($scope.irenginioEsamaGaliaValue !== "") {
			$scope.urlParams.irenginiogalia = $scope.irenginioEsamaGaliaValue;
		}

		setQueryData();
	};

	$scope.$watch("urlParams.paslauga", function () {
		setQueryData();
	});

	$scope.init = function () {
		if (typeof (searchObj.paslauga) !== 'undefined') {
			for (var p in $scope.paslaugos) {
				if ($scope.paslaugos[p].paslauga == searchObj.paslauga) {
					$scope.paslaugos[p].onClick();
					$scope.setUrlArgPaslauga(searchObj.paslauga);
				}
			}
		}
		if (typeof (searchObj.tipas) !== 'undefined') {
			for (var p in $scope.objektoTipai) {
				if ($scope.objektoTipai[p].title == searchObj.tipas) {
					$scope.objektoTipai[p].onClick();
					$scope.setUrlArgTipas(searchObj.tipas);
				}
			}
		}
		if (typeof (searchObj.galia) !== 'undefined') {
			if (parseInt(searchObj.galia) < 59) {
				for (var g in $scope.galiosPoreikiai) {
					if ($scope.galiosPoreikiai[g].value == parseInt(searchObj.galia)) {
						$scope.manualSelection = true;
						$scope.galiosPoreikiaiValue = $scope.galiosPoreikiai[g].value;
						$scope.urlParams.galia = $scope.galiosPoreikiai[g].value;
					}
				}
			}
			else {
				$scope.galiosPoreikiaiValue = 60;
				$scope.customSelected = true;
				$scope.customGaliosPoreikisValue = parseInt(searchObj.galia);
				$scope.urlParams.galia = $scope.customGaliosPoreikisValue;

			}
			if ($scope.butasSelected || $scope.statiniaiSelected) {
				$scope.galiosPoreikis = false;
				$scope.vietosNustatymas = true;
				$scope.addBreadcrumb('Galios poreikis: ' + ($scope.galiosPoreikiaiValue !== null ? $scope.galiosPoreikiaiValue : $scope.customGaliosPoreikisValue) + ' kW');
			}
			$scope.setUrlArgGalia();

			//				setQueryData();
		}
		if (typeof (searchObj.ikrovimostotele) !== 'undefined') {
			$scope.ikrovimoStotele = false;
			if ($scope.butasSelected) {
				$scope.vietosNustatymas = true;
				$scope.galiosPoreikis = false;
			}
			else if ($scope.namasSelected && $scope.urlParams.galia == "") {
				$scope.vietosNustatymas = false;
				$scope.galiosPoreikis = true;
			}

			if (parseInt(searchObj.ikrovimostotele) > 0) {
				$scope.ikrovimoStoteleReikalinga = true;
			}
			else {
				$scope.ikrovimoStoteleReikalinga = false;
			}

			$scope.setUrlArgIkrovimoStotele();
			if ($scope.namasSelected && parseInt($scope.urlParams.galia) > 0) {
				$scope.vietosNustatymas = true;
				$scope.galiosPoreikis = false;
				$scope.addBreadcrumb('Galios poreikis: ' + ($scope.galiosPoreikiaiValue !== null ? $scope.galiosPoreikiaiValue : $scope.customGaliosPoreikisValue) + ' kW');
			}
		}
		if (typeof (searchObj.duomenys) !== 'undefined') {
			for (var d in $scope.duomenys) {
				if ($scope.duomenys[d].duomenys == searchObj.duomenys) {
					$scope.duomenys[d].onClick();
				}
			}
		}
		if (typeof (searchObj.esamagalia) !== 'undefined') {
			$scope.galiosPoreikis = false;
			$scope.vietosNustatymas = true;
			$scope.setUrlArgEsamaGalia(searchObj.esamagalia);

			if ((!$scope.irenginioGalia && $scope.galiosPoreikis && typeof (searchObj.objektas) !== 'undefined')) {
				$scope.addBreadcrumb('Esama galia: ' + $scope.esamaGaliaValue + 'kW');
			}
			if (parseInt($scope.urlParams.esamagalia) > 0 && parseInt($scope.urlParams.galia) > 0) {
				$scope.esamaGalia = false;
				$scope.addBreadcrumb('Galios poreikis: ' + ($scope.galiosPoreikiaiValue !== null ? $scope.galiosPoreikiaiValue : $scope.customGaliosPoreikisValue) + ' kW');
			}
			else if (parseInt($scope.urlParams.esamagalia) > 0 && $scope.urlParams.galia == "") {
				$scope.esamaGalia = false;
				$scope.galiosPoreikis = true;
			}
		}
		if (typeof (searchObj.objektas) !== 'undefined') {
			$scope.object_nr = parseInt(searchObj.objektas);
			$scope.object_address = parseInt(searchObj.adresas);

			$scope.duomenisIvesiuPats = true;
			$scope.objektoInformacija = false;
			$scope.irenginioGalia = true;

			$scope.setUrlArgObjektas();

			$scope.searchObject();


			if (typeof (searchObj.esamagalia) !== 'undefined') {
				if ($scope.irenginioEsamaGaliaValue === null) {
					$scope.galiosPoreikis = false;
					$scope.vietosNustatymas = false;
				}
			}
		}
		if (typeof (searchObj.irenginiogalia) !== 'undefined') {
			$scope.irenginioGalia = false;
			$scope.galiosPoreikis = true;

			$scope.irenginioEsamaGaliaValue = parseInt(searchObj.irenginiogalia)

			$scope.setUrlArgObjEsamaGalia();

			if (typeof (searchObj.atstumas) !== 'undefined') {
				$scope.galiosPoreikiaiValue = parseInt(searchObj.irenginiogalia);
				$scope.addBreadcrumb('Galios poreikis: ' + ($scope.galiosPoreikiaiValue !== null ? $scope.galiosPoreikiaiValue : $scope.customGaliosPoreikisValue) + ' kW');
			}
		}
		if (typeof (searchObj.atstumas) !== 'undefined') {
			$scope.galiosPoreikis = false;
			$scope.setUrlArgAtstumas();
			$scope.vietosNustatymasInput = parseInt(searchObj.atstumas);

			if (typeof (searchObj.irenginiogalia) !== 'undefined') {
				$scope.searchObject();
				$scope.distanceByObjektoNr();
			}
			else {
				$scope.patvirtintiAtstuma();
			}


		}
	};

	$scope.init();

}]);

EwSiteApp.controller('elecElasticSearchCtrl', ['$scope', '$timeout', '$log', 'ajaxSearch', function ($scope, $timeout, $log, ajaxSearch) {

}]);